import React, { useEffect, useState, useCallback } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase/firebase';
import Sidebar from './Sidebar';
import TopHeader from './shared/TopHeader';
import '../styles/Dashboard.css';

const PAGE_TITLES = {
  '/admin':              'Platform Overview',
  '/admin/applications': 'Applications',
  '/admin/companies':    'Companies',
  '/admin/employees':    'All Users',
  '/admin/vendors':      'Vendors',
  '/admin/settings':     'Settings',
};

const DashboardLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [verifying, setVerifying] = useState(true);
  const [adminEmail, setAdminEmail] = useState(null);

  // Pages can register their topbar Add CTA via the Outlet context.
  const [pageContext, setPageContext] = useState({});
  const registerPageContext = useCallback((ctx) => setPageContext(ctx || {}), []);

  // Reset page context when navigating between routes.
  useEffect(() => {
    setPageContext({});
  }, [location.pathname]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user || !user.email) {
        localStorage.removeItem('superAdminAuth');
        localStorage.removeItem('adminUser');
        navigate('/admin/login', { replace: true });
        return;
      }

      const email = user.email.toLowerCase();
      try {
        const snap = await getDoc(doc(db, 'superAdmins', email));
        if (!snap.exists()) {
          await signOut(auth);
          localStorage.removeItem('superAdminAuth');
          localStorage.removeItem('adminUser');
          navigate('/admin/login', { replace: true });
          return;
        }
        localStorage.setItem('superAdminAuth', 'true');
        localStorage.setItem('adminUser', email);
        setAdminEmail(email);
        setVerifying(false);
      } catch (err) {
        console.error('Super admin verification failed:', err);
        await signOut(auth);
        navigate('/admin/login', { replace: true });
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  if (verifying) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f8fafc',
        color: '#64748b',
        fontFamily: 'Plus Jakarta Sans, sans-serif',
        fontSize: 14,
      }}>
        Verifying access…
      </div>
    );
  }

  const title = PAGE_TITLES[location.pathname] || 'Dashboard';
  const initials = (adminEmail || 'SA').split('@')[0].slice(0, 2).toUpperCase();

  return (
    <div className="loysta-app">
      <Sidebar adminEmail={adminEmail} />
      <div className="loysta-main">
        <TopHeader
          title={title}
          userInitials={initials}
          addLabel={pageContext.addLabel}
          onAdd={pageContext.onAdd}
        />
        <main className="loysta-content">
          <Outlet context={{ registerPageContext }} />
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
